import { z } from "zod";
import { checkNickname } from "./nickname";
import { aiPlayerIds, engineConfig, gameSettings } from "./seed";

// ---------- path parameters ----------

const codeChars = gameSettings.codeAlphabet.replace(/[\\\]^-]/g, "\\$&");
const codeRegex = new RegExp(`^[${codeChars}]{${gameSettings.codeLength}}$`);

/** Game code, case-insensitive on input, upper case after parsing. */
export const gameCodeSchema = z
  .string()
  .trim()
  .transform((s) => s.toUpperCase())
  .pipe(z.string().regex(codeRegex, "Virheellinen pelikoodi."));

export const roundNoSchema = z.coerce.number().int().min(1).max(engineConfig.months);

export const playerIdSchema = z.string().regex(/^(p_[0-9A-HJKMNP-TV-Z]{26}|ai_[a-z0-9]+)$/);

// ---------- request bodies ----------

export const createGameBodySchema = z.object({
  aiPlayers: z
    .array(z.enum(aiPlayerIds))
    .max(aiPlayerIds.length)
    .refine((a) => new Set(a).size === a.length, "AI-pelaaja on listattu kahdesti."),
});
export type CreateGameBody = z.infer<typeof createGameBodySchema>;

export const joinGameBodySchema = z.object({
  nickname: z.string().transform((raw, ctx) => {
    const r = checkNickname(raw);
    if (!r.ok) {
      ctx.addIssue({ code: "custom", message: r.reason });
      return z.NEVER;
    }
    return r.nickname;
  }),
});
export type JoinGameBody = z.input<typeof joinGameBodySchema>;

export const choiceBodySchema = z.object({
  catchIndex: z
    .number()
    .int()
    .min(0)
    .max(engineConfig.catchesPerRound - 1),
});
export type ChoiceBody = z.infer<typeof choiceBodySchema>;

/** Header carrying the anonymous player token (SPEC §5). */
export const PLAYER_TOKEN_HEADER = "x-player-token";

/** localStorage key for the player token. */
export const playerTokenStorageKey = (code: string) => `kalaporssi:${code}`;
